import React from 'react';

import PropTypes from 'prop-types';
import Select from 'react-select';

import * as APPDATA from '@/constants/pcConstAppData';

import './TimezoneSelection.less';

function TimezoneSelection({label, options, value, onChange, disabled}) {
  return (
    <div
      className="timezone-selection div-2col"
      disabled={disabled}
    >
      <p>{label}</p>
      <Select
        style={{width: '400px', fontSize: '20px'}}
        id={APPDATA.FIELD_NAME.MEMBRANE_CUT_OFF_SIZE}
        name="form-field-name"
        options={options}
        className="selectTimezone"
        value={value}
        valueStyle={{textAlign: 'left'}}
        onChange={onChange}
        clearable={false}
        searchable={false}
        placeholder=""
        menuContainerStyle={{
          top: '100%',
          bottom: 'auto',
          maxHeight: '300px',
          width: '400px',
          fontSize: '20px',
          textAlign: 'left',
        }}
        disabled={disabled}
      />
    </div>
  );
}

TimezoneSelection.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  options: PropTypes.array,
};

TimezoneSelection.defaultProps = {
  value: null,
  disabled: false,
  onChange: () => {},
  label: '',
  options: [],
};

export default TimezoneSelection;
